import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react'
import { faShieldHalved, faWarning } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

interface Props {
  isOpen: boolean
  onClose: () => void
}

const BetaWarningModal: React.FC<Props> = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}} // Prevent closing via overlay or escape key
      closeOnOverlayClick={false} // Disable overlay click to close
      closeOnEsc={false} // Disable escape key to close
    >
      <ModalOverlay bg={'rgba(0, 0, 0,0.85)'} />
      <ModalContent rounded="14px" p="0px" maxW="600px" marginX="16px">
        <div className="bg-brand-light-background dark:bg-brand-dark-background rounded-xl relative">
          {/* Header without X button */}
          <div className="p-5 pb-5">
            <p className="text-default-base">Beta Feature Warning</p>
          </div>

          <div className="p-6 pt-0">
            <div className="flex mt-4">
              <div className="w-[36px] text-brand-accent flex-shrink-0">
                <FontAwesomeIcon icon={faWarning} />
              </div>
              <div>
                <p className="text-default mb-1">This is a beta feature</p>
                <p className="text-description">
                  Please double-check all details before proceeding, and verify
                  everything in your wallet connector with regards to what
                  network you are connected to and are signing the transaction
                  for. Use at your own risk and ensure all information is
                  correct before proceeding with any transactions.
                </p>
              </div>
            </div>

            <div className="flex mt-4">
              <div className="w-[36px] text-brand-accent flex-shrink-0">
                <FontAwesomeIcon icon={faShieldHalved} />
              </div>
              <div>
                <p className="text-default mb-1">
                  THORChain is a third-party provider
                </p>
                <p className="text-description">
                  We simply relay information and instructions from the
                  THORChain network. THORChain performs the actual
                  transactions/swaps, and we are not capable of recovering lost
                  funds as this mechanism is out of our hands. Always verify
                  transaction details carefully as transactions cannot be
                  reversed once submitted.
                </p>
              </div>
            </div>

            <div className="pt-6">
              <button onClick={onClose} className="w-full button">
                I Understand the Risks
              </button>
            </div>
          </div>
        </div>
      </ModalContent>
    </Modal>
  )
}

export default BetaWarningModal
